import React from "react";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
import { connect } from "react-redux";
import { Button, Card, Row, Col, Form, Modal, notification, Tooltip, Popconfirm } from "antd";
import { TableComp, FormUtils as GetAllFormFields } from "sz-react-utils";
import _, { sortBy } from 'lodash';
import { API_URL } from "../../../../request";
import Request from "../../../../request";
import { RightsWrapper } from "../../../../components/_utils/utils";

@Form.create()
class UniversityMergeDrawer extends React.Component {
    state = {
        visible: true,
        universitiesArr: []
    }

    loadUniversities = async () => {
        Request.getUniversities({
            results: 10000,
            count: 10000,
            sortField: 'universityInstitutionName',
            sortOrder: 'ascend',
            universityStatus:'Active'
        }).then(resp => {
            resp.data = resp.data.reduce((temp, vv) => {
                temp.push({ _id: vv._id, display: vv.universityInstitutionName });
                return temp;
            }, [])
            this.setState({ universitiesArr: resp.data });
        }).catch(err => {
            console.log(err)
        })
    }

    componentDidMount() {
        this.loadUniversities()
    }

    handleSubmit = (e) => {
        let { form } = this.props;
        let {universitiesArr} = this.state;
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            let foundUniversityToMerge = await universitiesArr.find((obj)=>{
                return obj._id === values.universityToMerge
            })
            let foundMergingUniversity = await universitiesArr.find((obj)=>{
                return obj._id === values.mergingUniversity
            })
            if(foundUniversityToMerge) {
                values.universityToMergeName = foundUniversityToMerge.display;
            }
            if(foundMergingUniversity) {
                values.mergingUniversityName = foundMergingUniversity.display;
            }
            let response = await Request.addUniversityMergeRequest(values);
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
            this.handleCancel();
        })
    }

    handleOk = e => {
        this.setState({
            visible: false,
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false,
        });
        setTimeout(() => {
            this.props.onClose();
        }, 100)
    };

    render() {
        let { visible, universitiesArr } = this.state;
        let { form: { getFieldDecorator, setFieldsValue } } = this.props;

        const inputTypes = {
            fields: [
                {
                    label: 'University To Merge',
                    key: 'universityToMerge',
                    type: 'select',
                    showSearch: true,
                    options: universitiesArr,
                    prefixComp: "Choose University You Want to Merge",
                    onChange: v => {
                        setFieldsValue({ universityToMerge: v })
                    }
                },
                {
                    label: 'University Name',
                    key: 'mergingUniversity',
                    type: 'select',
                    showSearch: true,
                    options: universitiesArr,
                    prefixComp: "Choose University You Want to Merge In",
                    onChange: v => {
                        setFieldsValue({ mergingUniversity: v })
                    }
                },
            ]
        }
        return (
            <Modal title="University Merge Request" width={820} visible={visible} onOk={this.handleOk} onCancel={this.handleCancel} footer={[]}>
                <Form onSubmit={this.handleSubmit}>
                    <GetAllFormFields api={API_URL} inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} />
                    <Row style={{ marginTop: '20px' }}>
                        <Col span={8} />
                        <Col span={8}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{ marginBottom: 10 }}
                                loading={this.props.loading}>
                                Save
                            </Button>
                        </Col>
                        <Col span={8} />
                    </Row>
                </Form>
            </Modal>
        )
    }
}


class MergeUniversity extends React.Component {
    state = {
        count: 0,
        showMergeDrawer: false
    }

    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

    componentDidMount() {

    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let response = await Request.getUniversityMergeRequests(params)
            this.setState({count:response.total})
            return resolve(response)
        })
    }

    showModal = () => {
        this.setState({ showMergeDrawer: true })
    }

    closeMergeDrawer = () => {
        this.setState({ showMergeDrawer: false }, () => {
            this.table.current.reload()
        })
    }

    handleDelete = async(recordId) =>{
        let response = await Request.deleteMergeRequest({_id:recordId});
        if(response.success) {
            notification.success({
                message:response.message
            })
        }else {
            notification.error({
                message:response.message
            })
        }
        this.table.current.reload();
    }

    render() {
        let { count, showMergeDrawer } = this.state;
        const columns = [
            {
                title: 'Sr. No',
                key: 'serialNumber',
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'University To Merge',
                key: 'universityToMergeName',
                searchTextName:'University To Merge'
            },
            {
                title: 'University Merge In ',
                key: 'mergingUniversityName',
                searchTextName:'University Merge In'
            },
            {
                title: 'Merge Status',
                key: 'status',
                filters:[{value: 'Pending', text: 'Pending'},{value: 'Completed', text: 'Completed'}],
                filterRegex:true
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    <div>
                        <RightsWrapper myRight={"mergeUniversity.view"}>
                        <Tooltip title="Delete Merge Request">
                            <Popconfirm
                                title="Are you sure to delete?"
                                onConfirm={() => this.handleDelete(record._id)}>
                                <Button size="small" icon="delete" shape="circle" />
                            </Popconfirm>
                        </Tooltip>
                        </RightsWrapper>
                    </div>
                )
            }
        ]
        return (
            <PageHeaderWrapper title={`University Merge Requests :- ${count}`}>
                {
                    showMergeDrawer ?
                        <UniversityMergeDrawer onClose={this.closeMergeDrawer} />
                        : null
                }
                <Card bordered={true} style={{ marginBottom: 10 }}>
                    <Row>
                        <Col span={4}>
                            <Button type="primary" onClick={() => this.showModal()}>Add</Button>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true}>
                    <TableComp
                        showSelector={true}
                        columns={columns}
                        ref={this.table}
                        apiRequest={(params) => this.apiRequest(params, columns)}
                        // extraProps={{ scroll: { x: 100 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ["10", "20", "50", "100", "1000"],
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}


const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search,
});

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MergeUniversity);